<template>
  <b-container>
    <b-row style="margin-top: 4em">
      <b-col>
        <h1 class="text-info">
          {{ /*$t("globals.import_tool")*/ "Import Tool" }}:
        </h1>
      </b-col>
    </b-row>
    <b-card bg-variant="light" class="m-1">
      <b-row class="m-3">
        <b-col sm="12" md="4" lg="3">
          <h3 class="text-secondary">1. Select model</h3>
        </b-col>
        <b-col>
          <b-form-select
            :state="selectedModel != null"
            v-model="selectedModel"
            :options="modelOptions"
          />
        </b-col>
      </b-row>
      <b-row class="m-3" v-if="selectedModel != null">
        <b-col sm="12" md="4" lg="3">
          <h3 class="text-secondary">2. Import</h3>
        </b-col>
        <b-col>
          <b-form-file
            v-model="file"
            :state="Boolean(file)"
            accept=".xlsx, .xls"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
          />
        </b-col>
      </b-row>
    </b-card>
    <!-- Model Settings -->
    <div v-if="selectedModel != null">
      <!-- Billing Devices -->
      <devices-settings-card
        v-if="selectedModel.type == 'billing_devices_stock'"
        :final_data="final_data"
        :spec_data="selectedModel.spec_data"
        :done="done"
      />
      <!-- User TODO-->
      <user-settings-card
        v-if="selectedModel.type == 'user'"
        :final_data="final_data"
        :spec_data="selectedModel.spec_data"
      />
      <!-- Poi -->
      <poi-settings-card
        v-if="(selectedModel.type == 'poi_addresses' ||
          selectedModel.type == 'poi_lat_lon')"
        :spec_data="selectedModel.spec_data"
        :type_import_by="selectedModel.type"
        :final_data="final_data"
        :done="done"
      />
      <!-- FuelEvent -->
      <fuel-events-settings-card
        v-if="selectedModel.type == 'fuel_events'"
        :spec_data="selectedModel.spec_data"
        :type_import_by="selectedModel.type"
        :final_data="final_data"
        :done="done"
      />
      <!-- Exact - Invoices TODO -->
      <exact-settings-card
        v-if="selectedModel.type == 'exact_invoices'"
        :final_data="final_data"
        :spec_data="selectedModel.spec_data"
      />
    </div>
    <!-- Map -->
    <b-card
      bg-variant="light"
      class="m-1"
      v-if="selectedModel != null && file != null"
    >
      <b-row class="m-3">
        <b-col>
          <h3 class="text-secondary">4. Map</h3>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col>
          <h5 class="text-secondary">Include:</h5>
        </b-col>
        <b-col>
          <h5 class="text-secondary">Model key:</h5>
        </b-col>
        <b-col>
          <h5 class="text-secondary">Csv key:</h5>
        </b-col>
        <b-col>
          <h5 class="text-secondary">Preview:</h5>
          <b-btn
            class="float-right m-1"
            variant="info"
            size="sm"
            @click="nextPreview"
            :disabled="!(this.selected_data_row < this.data_arr.length)"
            >Next</b-btn
          >
          <b-btn
            class="float-right m-1"
            variant="info"
            size="sm"
            @click="backPreview"
            :disabled="!(this.selected_data_row > 0)"
            >Back</b-btn
          >
        </b-col>
      </b-row>
      <b-row v-for="item in selectedModel.data" :key="item.text" class="m-2">
        <b-col>
          <ulu-item-row
            :item="item"
            :header_row="data_header"
            :data_row="data_arr[selected_data_row]"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-btn
            class="float-right m-3"
            variant="info"
            @click="submit"
            :disabled="submitDisabled"
          >
            {{
              final_data.length > 0 ? "Refresh preview table" : "Preview All"
            }}
          </b-btn>
        </b-col>
      </b-row>
    </b-card>
    <!-- Table Preview -->
    <b-card bg-variant="light" class="m-1" v-if="final_data.length > 0">
      <b-row>
        <b-col md="6" class="m-3">
          <b-input-group>
            <b-form-input
              v-model="filter"
              :placeholder="$t('globals.type_to_search')"
            />
            <b-input-group-append>
              <b-btn variant="warning" :disabled="!filter" @click="filter = ''">
                {{ $t("globals.clear") }}
              </b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-row>
        <b-table
          class="m-3"
          :filter="filter"
          :current-page="currentPage"
          :per-page="perPage"
          small
          :items="final_data"
          @filtered="onFiltered"
        >
        </b-table>
      </b-row>
      <b-row>
        <b-col md="6" class="my-1">
          <b-pagination
            :total-rows="final_data.length"
            :per-page="perPage"
            v-model="currentPage"
            class="my-0"
          />
        </b-col>
      </b-row>
    </b-card>
  </b-container>
</template>

<script>
import Papa from "papaparse";
import XLSX from "xlsx";

export default {
  components: {
    "devices-settings-card": () =>
      import("@/components/common/import_tool/SettingsDevicesCard"),
    "user-settings-card": () =>
      import("@/components/common/import_tool/SettingsUserCard"),
    "exact-settings-card": () =>
      import("@/components/common/import_tool/SettingsExactCard"),
    "poi-settings-card": () =>
      import("@/components/common/import_tool/SettingsPoiCard"),
    "fuel-events-settings-card": () =>
      import("@/components/common/import_tool/SettingsFuelEventsCard"),
    "ulu-item-row": () => import("@/components/common/import_tool/ItemRow")
  },
  data() {
    return {
      filter: null,
      currentPage: 1,
      perPage: 10,
      final_data: [],
      data_header: [],
      data_arr: [],
      selected_data_row: 0,
      selectedModel: null,
      file: null,
      modelOptions: [
        {
          text: "Billing Devices (To Stock)",
          value: {
            type: "billing_devices_stock",
            data: [
              {
                text: "IMEI",
                value: {
                  model_key: "imei",
                  csv_key: null,
                  required: true,
                  included: true
                }
              },
              {
                text: "Product",
                value: {
                  model_key: "product",
                  csv_key: null,
                  required: true,
                  included: true
                }
              },
              {
                text: "Batch",
                value: {
                  model_key: "batch",
                  csv_key: null,
                  required: false,
                  included: false
                }
              },
            ],
            spec_data: [
              {
                field_name: "IMEI",
                type: "Text",
                options: "eg. 358014099363636",
                required: true,
                _rowVariant: "success"
              },
              {
                field_name: "product",
                type: "Text",
                options: "Blackbox, Dongel...",
                required: true,
                _rowVariant: "success"
              },
              {
                field_name: "batch",
                type: "Text",
                options: "",
                required: false,
                _rowVariant: "info"
              }
            ]
          }
        },
        /*{
          text: "User",
          value: {
            type: "user",
            data: [
              {
                text: "First name",
                value: {
                  model_key: "firstname",
                  csv_key: null,
                  required: true,
                  included: true
                }
              },
              {
                text: "Last name",
                value: {
                  model_key: "lastname",
                  csv_key: null,
                  required: true,
                  included: true
                }
              },
              {
                text: "Email",
                value: {
                  model_key: "email",
                  csv_key: null,
                  required: true,
                  included: true
                }
              },
              {
                text: "Role",
                value: {
                  model_key: "role",
                  csv_key: null,
                  required: true,
                  included: true
                }
              },
              {
                text: "Phone",
                value: {
                  model_key: "phone",
                  csv_key: null,
                  required: false,
                  included: false
                }
              },
              {
                text: "Address",
                value: {
                  model_key: "address",
                  csv_key: null,
                  required: false,
                  included: false
                }
              },
              {
                text: "House no.",
                value: {
                  model_key: "housenumber",
                  csv_key: null,
                  required: false,
                  included: false
                }
              },
              {
                text: "City",
                value: {
                  model_key: "city",
                  csv_key: null,
                  required: false,
                  included: false
                }
              },
              {
                text: "Zip Code",
                value: {
                  model_key: "zip_code",
                  csv_key: null,
                  required: false,
                  included: false
                }
              },
              {
                text: "Vat no.",
                value: {
                  model_key: "vat_number",
                  csv_key: null,
                  required: false,
                  included: false
                }
              },
              {
                text: "Username",
                value: {
                  model_key: "username",
                  csv_key: null,
                  required: false,
                  included: false
                }
              }
            ],
            spec_data: [
              {
                field_name: "First name",
                type: "Text",
                options: "eg. Emma",
                required: true,
                _rowVariant: "success"
              },
              {
                field_name: "Last name",
                type: "Text",
                options: "eg. De Jong",
                required: true,
                _rowVariant: "success"
              },
              {
                field_name: "Email",
                type: "Text",
                options: "eg. emma.dejong@ulu.io",
                required: true,
                _rowVariant: "success"
              },
              {
                field_name: "Role",
                type: "Text",
                options: "driver, fleet_admin, custom",
                required: true,
                _rowVariant: "success"
              },
              {
                field_name: "Phone",
                type: "Number",
                options: "eg. 31 40 240 5555",
                required: false,
                _rowVariant: "info"
              },
              {
                field_name: "Address",
                type: "Text",
                options: "eg. Boeing Avenue",
                required: false,
                _rowVariant: "info"
              },
              {
                field_name: "House no.",
                type: "Text",
                options: "eg. 241",
                required: false,
                _rowVariant: "info"
              },
              {
                field_name: "City",
                type: "Text",
                options: "eg. Schiphol-Rijk",
                required: false,
                _rowVariant: "info"
              },
              {
                field_name: "Zip Code",
                type: "Text",
                options: "eg. 1119 PD",
                required: false,
                _rowVariant: "info"
              },
              {
                field_name: "Vat no.",
                type: "Text",
                options: "eg. NL854663630B01",
                required: false,
                _rowVariant: "info"
              },
              {
                field_name: "Username",
                type: "Text",
                options: null,
                required: false,
                _rowVariant: "info"
              },
            ]
          },
        },*/
        {
          text: "POI - Address",
          value: {
            type: "poi_addresses",
            data: [
              {
                text: "Name",
                value: {
                  model_key: "name",
                  csv_key: null,
                  required: true,
                  included: true
                }
              },
              {
                text: "Street",
                value: {
                  model_key: "street",
                  csv_key: null,
                  required: true,
                  included: true
                }
              },
              {
                text: "House no.",
                value: {
                  model_key: "house_number",
                  csv_key: null,
                  required: false,
                  included: false
                }
              },
              {
                text: "Zip Code",
                value: {
                  model_key: "zip_code",
                  csv_key: null,
                  required: true,
                  included: true
                }
              },
              {
                text: "City",
                value: {
                  model_key: "city",
                  csv_key: null,
                  required: true,
                  included: true
                }
              },
              {
                text: "Country",
                value: {
                  model_key: "country",
                  csv_key: null,
                  required: true,
                  included: true
                }
              },
              {
                text: "Hotspot type id",
                value: {
                  model_key: "hotspot_type_id",
                  csv_key: null,
                  required: true,
                  included: true
                }
              },
              {
                text: "Visibility",
                value: {
                  model_key: "visibility",
                  csv_key: null,
                  required: true,
                  included: true
                }
              },
              {
                text: "Radius",
                value: {
                  model_key: "radius",
                  csv_key: null,
                  required: true,
                  included: true
                }
              },
              {
                text: "Group name",
                value: {
                  model_key: "group_name",
                  csv_key: null,
                  required: false,
                  included: false
                }
              }
            ],
            spec_data: [
              {
                field_name: "Name",
                type: "Text",
                options: "eg. ULU B.V. HQ",
                required: true,
                _rowVariant: "success"
              },
              {
                field_name: "Street",
                type: "Text",
                options: "eg. Boeing Avenue",
                required: true,
                _rowVariant: "success"
              },
              {
                field_name: "House no.",
                type: "Text",
                options: "eg. 241",
                required: false,
                _rowVariant: "info"
              },
              {
                field_name: "Zip Code",
                type: "Text",
                options: "eg. 1119 PD",
                required: true,
                _rowVariant: "success"
              },
              {
                field_name: "City",
                type: "Text",
                options: "eg. Schiphol-Rijk",
                required: true,
                _rowVariant: "success"
              },
              {
                field_name: "Country",
                type: "Text",
                options: "eg. Netherland",
                required: true,
                _rowVariant: "success"
              },
              {
                field_name: "Hotspot type id",
                type: "Number",
                options:
                  "1 (Home Address), 2 (Work Address), 3 (Private Visit Address), 4 (Business Visit Address), 5 (Stop Poi Address), 6 (Enroute Location), 7 (Bussiness Visit Start/Stop Address), 8 (Other), 99 (Unknown)",
                required: true,
                _rowVariant: "success"
              },
              {
                field_name: "Visibility",
                type: "Text",
                options:
                  "public (All users in company), private_company (Company Admins)",
                required: true,
                _rowVariant: "success"
              },
              {
                field_name: "Radius",
                type: "Number",
                options: "50 - 1000 (meters)",
                required: true,
                _rowVariant: "success"
              },
              {
                field_name: "Group name",
                type: "Text",
                options: null,
                required: false,
                _rowVariant: "info"
              }
            ]
          }
        }, /*
        {
          text: "POI - Lat/Lon",
          value: {
            type: "poi_lat_lon",
            data: [
              {
                text: "Name",
                value: {
                  model_key: "name",
                  csv_key: null,
                  required: true,
                  included: true
                }
              },
              {
                text: "Lat",
                value: {
                  model_key: "lat",
                  csv_key: null,
                  required: true,
                  included: true
                }
              },
              {
                text: "Lon",
                value: {
                  model_key: "lon",
                  csv_key: null,
                  required: true,
                  included: true
                }
              },
              {
                text: "Hotspot type id",
                value: {
                  model_key: "hotspot_type_id",
                  csv_key: null,
                  required: true,
                  included: true
                }
              },
              {
                text: "Visibility",
                value: {
                  model_key: "visibility",
                  csv_key: null,
                  required: true,
                  included: true
                }
              },
              {
                text: "Radius",
                value: {
                  model_key: "radius",
                  csv_key: null,
                  required: true,
                  included: true
                }
              },
              {
                text: "Group name",
                value: {
                  model_key: "group_name",
                  csv_key: null,
                  required: true,
                  included: true
                }
              }
            ],
            spec_data: [
              {
                field_name: "Name",
                type: "String",
                options: "eg. ULU B.V. HQ",
                required: true,
                _rowVariant: "success"
              },
              {
                field_name: "Latitude",
                type: "Decimal",
                options: "eg. 52.2763223",
                required: true,
                _rowVariant: "success"
              },
              {
                field_name: "Longitude",
                type: "Decimal",
                options: "eg. 4.748414",
                required: true,
                _rowVariant: "success"
              },
              {
                field_name: "Hotspot type id",
                type: "Int",
                options: "1 (Home Address), 2 (Work Address), 3 (Private Visit Address), 4 (Business Visit Address), 5 (Stop Poi Address), 6 (Enroute Location), 7 (Bussiness Visit Start/Stop Address), 8 (Other), 99 (Unknown)",
                required: true,
                _rowVariant: "success"
              },
              {
                field_name: "Visibility",
                type: "String",
                options: "'public', 'private_company'",
                required: true,
                _rowVariant: "success"
              },
              {
                field_name: "Radius",
                type: "Int",
                options: "50 - 1000 (meters)",
                required: true,
                _rowVariant: "success"
              },
              {
                field_name: "Group name",
                type: "String",
                options: null,
                required: false,
                _rowVariant: "info"
              }
            ]
          }
        }*/ /*
        {
          text: "Exact - Invoices",
          value: {
            type: "exact_invoices",
            data: [
              {
                text: "Invoice no.",
                value: {
                  model_key: "invoice_no",
                  csv_key: null,
                  required: true,
                  included: true
                }
              },
              {
                text: "Paid",
                value: {
                  model_key: "paid",
                  csv_key: null,
                  required: true,
                  included: true
                }
              },
            ],
            spec_data: [
              {
                field_name: "invoice_no",
                type: "Text",
                options: "eg. 186533333",
                required: true,
                _rowVariant: "success"
              },
              {
                field_name: "paid",
                type: "Number",
                options: "eg. 0(not paid), 1(paid)",
                required: true,
                _rowVariant: "success"
              }
            ]
          }
        },*/
        {
          text: "Fuel Events",
          value: {
            type: "fuel_events",
            data: [
              {
                text: "License plate",
                value: {
                  model_key: "license_plate",
                  csv_key: null,
                  required: true,
                  included: true
                }
              },
              {
                text: "Date",
                value: {
                  model_key: "date",
                  csv_key: null,
                  required: true,
                  included: true
                }
              },
              {
                text: "Time",
                value: {
                  model_key: "time",
                  csv_key: null,
                  required: true,
                  included: true
                }
              },
              {
                text: "Location Name",
                value: {
                  model_key: "location_name",
                  csv_key: null,
                  required: true,
                  included: true
                }
              },
              {
                text: "Location Address",
                value: {
                  model_key: "location_address",
                  csv_key: null,
                  required: false,
                  included: true
                }
              },
              {
                text: "Fuel Type",
                value: {
                  model_key: "fuel_type",
                  csv_key: null,
                  required: true,
                  included: true
                }
              },
              {
                text: "Fuel Name",
                value: {
                  model_key: "fuel_name",
                  csv_key: null,
                  required: false,
                  included: true
                }
              },
              {
                text: "Provider",
                value: {
                  model_key: "provider",
                  csv_key: null,
                  required: true,
                  included: true
                }
              },
              {
                text: "Liters",
                value: {
                  model_key: "liters",
                  csv_key: null,
                  required: true,
                  included: true
                }
              },
              {
                text: "Price per liter",
                value: {
                  model_key: "price_per_liter",
                  csv_key: null,
                  required: true,
                  included: true
                }
              },
              {
                text: "Total ex vat",
                value: {
                  model_key: "total_ex_vat",
                  csv_key: null,
                  required: true,
                  included: true
                }
              },
              {
                text: "Total",
                value: {
                  model_key: "total",
                  csv_key: null,
                  required: true,
                  included: true
                }
              },
              {
                text: "Odometer",
                value: {
                  model_key: "odometer",
                  csv_key: null,
                  required: false,
                  included: true
                }
              }
            ],
            spec_data: [
              {
                field_name: "License plate",
                type: "Text",
                options: "eg. K-998-SR",
                required: true,
                _rowVariant: "success"
              },
              {
                field_name: "Date",
                type: "Text",
                options: "17.12.2024.",
                required: true,
                _rowVariant: "success"
              },
              {
                field_name: "Time",
                type: "Text",
                options: "05:03:23",
                required: true,
                _rowVariant: "info"
              },
              {
                field_name: "Location Name",
                type: "Text",
                options: "Shell",
                required: true,
                _rowVariant: "info"
              },
              {
                field_name: "Location address",
                type: "Text",
                options: "Boeing Avenue 241, 1119 PD Schiphol-Rijk, Netherlands",
                required: true,
                _rowVariant: "info"
              },
              {
                field_name: "Fuel type",
                type: "Text",
                options: "Possible options: gasoline, diesel, premiumdiesel, motoroil, premiumgasoline, oil, electric",
                required: true,
                _rowVariant: "info"
              },
              {
                field_name: "Fuel name",
                type: "Text",
                options: "Euro 95",
                required: false,
                _rowVariant: "info"
              },
              {
                field_name: "Provider",
                type: "Text",
                options: "shell, travelcard, varo, ...",
                required: true,
                _rowVariant: "info"
              },
              {
                field_name: "Liters",
                type: "Decimal",
                options: "How many liters was added, example: 27,28",
                required: true,
                _rowVariant: "info"
              },
              {
                field_name: "Price per liter",
                type: "Decimal",
                options: "Price of 1 liter of fuel in EUR. Example 1,12",
                required: true,
                _rowVariant: "info"
              },
              {
                field_name: "Total ex vat",
                type: "Decimal",
                options: "Fueling total price without VAT in EUR. Example 40,12",
                required: true,
                _rowVariant: "info"
              },
              {
                field_name: "Total",
                type: "Decimal",
                options: "Fueling total price with VAT in EUR. Example 44,12",
                required: true,
                _rowVariant: "info"
              },
              {
                field_name: "Odometer",
                type: "Integer",
                options: "Sometimes with fuleing also the currentodometer of the vehicle is sent (in km). Example 120000",
                required: false,
                _rowVariant: "info"
              }
            ]
          }
        },
      ]
    };
  },
  methods: {
    nextPreview() {
      if (this.selected_data_row < this.data_arr.length) {
        this.selected_data_row += 1;
      }
    },
    backPreview() {
      if (this.selected_data_row > 0) {
        this.selected_data_row -= 1;
      }
    },
    load() {
      const reader = new FileReader();
      reader.onload = e => {
        /* Parse data */
        const bstr = e.target.result;
        const wb = XLSX.read(bstr, { type: "binary" });
        /* Get first worksheet */
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        /* Convert array of arrays */
        const data = XLSX.utils.sheet_to_csv(ws, { header: 1 });

        let parsed_obj = Papa.parse(data);
        /* Update state */
        this.data_header = parsed_obj.data[0];
        parsed_obj.data.shift();
        this.data_arr = parsed_obj.data;
      };
      reader.readAsBinaryString(this.file);
    },
    submit() {
      let pairs = this.selectedModel.data
        .filter(item => item.value.included)
        .map(item => {
          return {
            model_key: item.value.model_key,
            csv_key: item.value.csv_key
          };
        });

      let temp_arr = [];
      this.data_arr.forEach(row => {
        let user = {};
        pairs.forEach(pair => {
          user[pair.model_key] = row[this.data_header.indexOf(pair.csv_key)];
        });
        temp_arr.push(user);
      });

      this.final_data = temp_arr;
    },
    onFiltered() {
      this.currentPage = 1;
    },
    done() {
      this.selectedModel = null;
    }
  },
  computed: {
    submitDisabled() {
      if (this.selectedModel) {
        return !(
          this.selectedModel.data.filter(item => item.value.included).length ==
          this.selectedModel.data.filter(item => item.value.csv_key != null)
            .length
        );
      } else {
        return true;
      }
    }
  },
  watch: {
    selectedModel: function() {
      this.file = null;
      this.final_data = [];
    },
    file: function(newFileVal) {
      if (newFileVal != null) {
        this.load();
      }
    }
  }
};
</script>
